import React, { useMemo } from "react";
import MaterialTable from "@material-table/core";
import useSWRInfinite from "swr/infinite";
import { fetcher } from "../../helpers/fetchHandleError";
import { Box, Button, Container } from "@mui/material";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

import { downloadCSVWithBom } from "../../helpers/methods";
import { useIsBusinessPlan } from "../../helpers/subscriptionPlan";
import { useRecordContext, useResourceContext } from "react-admin";
import { useProfileLocale } from "../Common/locale";

const PAGE_SIZE = 100;
const methodDescription = {
  POST: "Create",
  PUT: "Update",
  DELETE: "Delete",
  GET: "Get",
};

const UserActionByResource = (props) => {
  const resource = useResourceContext();

  const { _id } = useRecordContext();
  const isBusinessPlan = useIsBusinessPlan();
  const locale = useProfileLocale();
  const fullPathFilter = `/${resource}/${_id}`.toLowerCase();
  const fullPathQuery = encodeURIComponent(fullPathFilter);
  const { data, mutate, size, setSize, isValidating, isLoading } =
    useSWRInfinite(
      (index) =>
        `${process.env.REACT_APP_CLOUDFLARE_HOST}/api/user-actions?offset=${
          index * PAGE_SIZE
        }&fullPath=${fullPathQuery}`,
      fetcher
    );

  const columns = useMemo(() => {
    return [
      {
        title: "userId",
        field: "userId",
        editable: "never",
      },
      {
        title: "username",
        field: "username",
        editable: "never",
      },
      {
        title: "method",
        field: "method",
        editable: "never",
        render: (rowData) => {
          return (
            <span>{`${methodDescription[rowData.method]}(${
              rowData.method
            })`}</span>
          );
        },
      },
      // { title: "resource", field: "resource", editable: "never" },
      { title: "payload", field: "payload", editable: "never" },
      // { title: "fullPath", field: "fullPath", editable: "never" },
      {
        title: "created",
        field: "createdAt",
        editable: "never",
        render: (rowData) => (
          <span>
            {new Date(`${rowData.createdAt}Z`).toLocaleString(locale)}
          </span>
        ),
      },
    ];
  }, []);

  const keywordEvents = data ? [].concat(...data) : [];
  const isLoadingMore =
    isLoading || (size > 0 && data && typeof data[size - 1] === "undefined");
  const isEmpty = data?.[0]?.length === 0;
  const isReachingEnd =
    isEmpty || (data && data[data.length - 1]?.length < PAGE_SIZE);
  const isRefreshing = isValidating && data && data.length === size;

  return (
    <Container>
      <p>User actions only keeps for 14 days.</p>
      <Box marginY={3}>
        <MaterialTable
          isLoading={isLoading}
          title="User actions"
          columns={columns}
          data={keywordEvents}
          options={{
            padding: "dense",
            maxBodyHeight: 300,
            pageSize: 10000,
          }}
          components={{
            Pagination: (props) => (
              <td style={{ display: "block" }}>
                <Box display="flex" justifyContent="flex-end" m={1} p={1}>
                  {isBusinessPlan && (
                    <Box marginX={1}>
                      <Button
                        color="secondary"
                        disabled={isEmpty}
                        onClick={() => {
                          const sanitized = keywordEvents.map((e) => {
                            const {
                              pageId,
                              pagePsid,
                              pageIgsid,
                              createdAt,
                              ...others
                            } = e;
                            return {
                              ...others,
                              createdAt: new Date(
                                `${createdAt}Z`
                              ).toLocaleString(locale),
                            };
                          });

                          const csv = convertToCSV(sanitized, {
                            quotes: true,
                          });

                          downloadCSVWithBom(
                            csv,
                            `userActions_${new Date().toLocaleDateString(
                              locale
                            )}`
                          );
                        }}
                      >
                        Export
                      </Button>
                    </Box>
                  )}
                  <Box marginX={1}>
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={
                        isReachingEnd ||
                        isRefreshing ||
                        isLoading ||
                        isLoadingMore
                      }
                      onClick={() => setSize(size + 1)}
                    >
                      Load more
                    </Button>
                  </Box>
                </Box>
              </td>
            ),
          }}
        />
      </Box>
    </Container>
  );
};
export default UserActionByResource;
